<script setup lang="ts">
import type {RelationFilter, RelationFilters} from "@/types/Wiser/relation.ts";
import {ref, watch} from "vue";

const model = defineModel<RelationFilter>({required: true});
const filters = ref<RelationFilters>({relatietype:''})
watch(filters, (newValue) => {
  const filterString = Object.entries(newValue)
    .filter(([, value]) => value !== '')
    .map(([key, value]) => `${key}${['bedrijfsnaam','voornaam','achternaam'].includes(key)?'%=':'='}${encodeURIComponent(value)}`)
    .join(',')
  model.value.filters = encodeURI(filterString);
}, {deep: true})
</script>

<template>
  <form class="wiser-filter__form relation-filter__form">
    <input v-model="filters.id" placeholder="Wiser ID" type="text" />
    <select v-model="filters.relatietype">
      <option value="" class="placeholder">Relatie type</option>
      <option value="bedrijf">Bedrijf</option>
      <option value="particulier">Particulier</option>
      <option value="zzp">ZZP</option>
    </select>
    <input v-model="filters.bedrijfsnaam" placeholder="Bedrijfsnaam" type="text" />
    <input v-model="filters.voornaam" placeholder="Voornaam" type="text" />
    <input v-model="filters.achternaam" placeholder="Achternaam" type="text" />
    <select v-model="model.page">
      <option v-for="num of [...Array(25).keys()]" :value="String(num + 1)">{{ num + 1 }}</option>
    </select>
    <select v-model="model.perPage">
      <option v-for="num of [...Array(4).keys()]" :value="String((num + 1)*25)">{{ (num + 1)*25 }}</option>
    </select>
  </form>
</template>

<style scoped>
 form {
   width: 100%;
 }
</style>
